var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper w-100" },
    [
      _c(
        "el-table",
        { staticClass: "w-100", attrs: { data: _vm.items } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", sortable: "", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "user",
              label: "User",
              width: "170",
              formatter: _vm.formatUserRow,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "read_only", label: "Read Only", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row: { read_only } }) {
                  return [
                    _c("read-only-column", {
                      attrs: { "read-only": read_only },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "note", label: "Note" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row: { note } }) {
                  return [
                    _c("div", {
                      staticClass: "message message-body",
                      domProps: { textContent: _vm._s(note) },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }